import React, { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from '@reach/router';

interface IIntroContext {
    isPlaying: boolean;
    isComplete: boolean;
    showIntro(): void;
    closeIntro(): void;
}

const initialContext: IIntroContext = {
    isPlaying: false,
    isComplete: false,
    showIntro: () => {},
    closeIntro: () => {},
};
const IntroContext = createContext(initialContext);

export const IntroContextProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
    const { pathname } = useLocation();
    const [isPlaying, setIsPlaying] = useState<boolean>(false);
    const [isComplete, setIsComplete] = useState(false);

    const handleClose = () => {
        setIsPlaying(false);
        sessionStorage.setItem('introPlayed', 'played');
        setIsComplete(true);
    };

    useEffect(() => {
        const shouldPlay = shouldIntroPlay(pathname);
        setIsPlaying(shouldPlay);
        setIsComplete(!shouldPlay);
    }, [pathname]);

    return (
        <IntroContext.Provider
            value={{
                isPlaying,
                isComplete,
                showIntro: () => setIsPlaying(true),
                closeIntro: () => handleClose(),
            }}
        >
            {children}
        </IntroContext.Provider>
    );
};

function shouldIntroPlay(pathname: string): boolean {
    if (typeof sessionStorage === 'undefined') return false;
    if (pathname !== '/') return false;
    const alreadyPlayed = sessionStorage.getItem('introPlayed');
    if (!alreadyPlayed) {
        sessionStorage.setItem('introPlayed', '');
        return true;
    }
    return false;
}

export const useIntroContext = () => {
    const context = useContext(IntroContext);

    if (context === undefined) {
        throw new Error('useModalContext was used outside of its Provider');
    }

    return context;
};
